// extracted by css-extract-rspack-plugin
module.exports =  {"root":"ProviderSection__root___Z82q0","provider":"ProviderSection__provider___CNoIo","username":"ProviderSection__username___6RnQ6","email":"ProviderSection__email___iZfVQ"};